export default "__VITE_ASSET__zfQNqfRC__"